export default "__VITE_ASSET__6BECO2sL__"